import React from 'react';
import Reveal from './Reveal';
import './ImageSlider.css';

function ImageSlider() {
  const slides = [
    { id: 1, image: 'slider-1.jpg' },
    { id: 2, image: 'slider-2.jpg' },
    { id: 3, image: 'slider-3.jpg' }
  ];

  return (
    <div className="image-slider">
      {slides.map((slide, index) => (
        <section key={slide.id} className="slider-section">
          <div 
            className="slider-background"
            style={{ 
              backgroundImage: `url(${process.env.PUBLIC_URL}/${slide.image})`
            }}
          >
            <div className="slider-overlay"></div>
          </div>
          {index === 0 && (
            <>
              <div className="slider-text-left">
                <Reveal>
                  <h2>Tabia, un grupo empresarial en constante evolución</h2>
                </Reveal>
              </div>
              <div className="slider-text-bottom-right">
                <Reveal delay={200}>
                  <p>Acompañamos a nuestras participadas como socios comprometidos, con foco en la excelencia y la eficiencia operativa.</p>
                </Reveal>
              </div>
            </>
          )}
          {index === 1 && (
            <>
              <div className="slider-text-left">
                <Reveal>
                  <h2>Diversificando sin fronteras</h2>
                </Reveal>
              </div>
              <div className="slider-text-bottom-right">
                <Reveal delay={200}>
                  <p>Trabajamos estrechamente con cada cliente para entender sus necesidades específicas y diseñar soluciones a medida que les permitan alcanzar sus objetivos de manera eficiente.</p>
                </Reveal>
              </div>
            </>
          )}
          {index === 2 && (
            <>
              <div className="slider-text-left">
                <Reveal>
                  <h2>Un grupo empresarial en constante evolución</h2>
                </Reveal>
              </div>
              <div className="slider-text-bottom-right">
                <Reveal delay={200}>
                  <p>Identificamos y gestionamos inversiones inmobiliarias estratégicas con un enfoque patrimonial, orientadas a generar rentabilidad sólida y sostenible, aportando valor económico y social en los mercados en los que operamos.</p>
                </Reveal>
              </div>
            </>
          )}
        </section>
      ))}
    </div>
  );
}

export default ImageSlider;
